import React from 'react';

function Button({ onClick, className, children, ...props }) {
    return (
        <button onClick={onClick} className={`site-btn ${className}`} {...props}>
            {children}
        </button>
    );
}

export default Button;